import { useTranslation } from "react-i18next"
import { Referral } from "../../types/Referral"
import { Badge } from "../Badge"

interface Props {
  status?: Referral["status"]
}

function getBadgeVariant(status?: Referral["status"]) {
  if (status === "New") {
    return "attention"
  } else if (status === "Fraud") {
    return "critical"
  } else if (status === "Review in Progress") {
    return "info"
  } else if (status === "Rejected") {
    return "critical"
  } else if (status === "Incomplete") {
    return "info"
  } else if (status === "Complete") {
    return "success"
  }

  return "neutral"
}

export function StatusBadge({ status }: Props) {
  const { t } = useTranslation()
  return (
    <Badge variant={getBadgeVariant(status)}>
      {t(`admin.status.${status}`)}
    </Badge>
  )
}
